import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M12.74 2.048a4.12 4.12 0 0 1 2.89 1.184 4.163 4.163 0 0 1 .06 5.878L9 15.519l-6.69-6.41a4.163 4.163 0 0 1 .06-5.877 4.12 4.12 0 0 1 2.89-1.184h.06a4.015 4.015 0 0 1 1.816.445c.545.28 1.021.678 1.394 1.164l.47.592.47-.592c.373-.486.85-.883 1.394-1.164a4.015 4.015 0 0 1 1.816-.445h.06Zm0-1.125h-.076c-.806.007-1.598.202-2.315.57a5.33 5.33 0 0 0-1.348.993c-.395-.4-.85-.735-1.349-.993a5.165 5.165 0 0 0-2.326-.57H5.26a5.215 5.215 0 0 0-3.68 1.508 5.298 5.298 0 0 0-.075 7.465l6.717 6.435.778.746.778-.746 6.69-6.409a5.305 5.305 0 0 0-.049-7.492A5.214 5.214 0 0 0 12.74.923h.001Z",
    fill: "#2B2E2F"
  })
], -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h18v18H0z"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render: render }